import {Badge, Box, Divider, Icon, Stack, Typography} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import { matchPath, useNavigate } from "react-router-dom";
import { MenuDefinition } from "../../constants/MenuConstants";
import {IntegrationContext} from "../../contexts/IntegrationContext";

export default function DrawerMenuItem(props: {
    menuItem: MenuDefinition;
    toggleDrawer: () => void;
}) {
    const item = props.menuItem;

    const navigate = useNavigate();

    const isSelfMatch = !!matchPath(window.location.pathname, item.url);

    let isAnyChildMatch =
        props.menuItem.children &&
        props.menuItem.children.some((c) => {
            return !!matchPath(window.location.pathname, c.url);
        });

    const isMatch = isSelfMatch || (isAnyChildMatch ?? false);

    const [isOpen, setIsOpen] = useState<boolean>(isMatch);

    const hasChildren = props.menuItem.children;

    // ------------------ Logic to implement badge number ----------------------------//
    const [badgeCount, setBadgeCount] = useState<number | string | null>(null);
    const integrationContext = useContext(IntegrationContext);
    useEffect(() => {
        if (integrationContext.badgeNeedsRefresh) {
            getBadgeCountIfNeeded();
        }
    }, [integrationContext.badgeNeedsRefresh]);

    const getBadgeCountIfNeeded = async () => {
        if (props.menuItem.badgeCountResolver) {
            const result = await props.menuItem.badgeCountResolver();
            setBadgeCount(result);
            integrationContext.onBadgeFetched();
        }
    };
    // -----------------------------End Badge  --------------------------------------//


    const handleClick = (menuItem: MenuDefinition) => {
        if (menuItem.children) {
            setIsOpen(!isOpen);
        } else {
            props.toggleDrawer();
            navigate(menuItem.url);
        }
    };

    return (
        <>
            <Box key={item.title}>
                <Stack
                    spacing={2}
                    direction="row"
                    sx={{
                        bgcolor:
                            isMatch && !hasChildren
                                ? "background.default"
                                : "packground.paper",
                        px: 2,
                        py: 2,
                    }}
                    onClick={() => handleClick(props.menuItem)}
                >
                    <Icon color={isMatch ? "primary" : "disabled"}>
                        {item.icon}
                    </Icon>

                    <Typography color={isMatch ? "primary" : "text.secondary"}>
                        <Badge
                            sx={{ p: 0.3 }}
                            badgeContent={
                                badgeCount ? (
                                    <Box sx={{ fontFamily: "system-ui !important" }}>
                                        {badgeCount}
                                    </Box>
                                ) : null
                            }
                            color="error"
                        >
                            {item.title}
                        </Badge>
                    </Typography>

                    <Box flexGrow={1} />

                    {hasChildren && (
                        <Icon color={isMatch ? "primary" : "disabled"}>
                            {isOpen ? "expand_less" : "expand_more"}
                        </Icon>
                    )}

                    {/*{!hasChildren && (*/}
                    {/*    <Icon color={isMatch ? "primary" : "disabled"}>*/}
                    {/*        chevron_left*/}
                    {/*    </Icon>*/}
                    {/*)}*/}
                </Stack>
            </Box>

            {hasChildren && isOpen && (
                <>
                    <Divider />
                    {props.menuItem.children!.map((c) => {
                        const isChildMatch = matchPath(
                            window.location.pathname,
                            c.url
                        );

                        return (
                            <Box key={c.title}>
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{
                                        px: 4,
                                        py: 1.5,
                                        bgcolor: isOpen
                                            ? "background.default"
                                            : "packground.paper",
                                    }}
                                    onClick={() => handleClick(c)}
                                >
                                    <Icon
                                        color={
                                            isChildMatch
                                                ? "primary"
                                                : "disabled"
                                        }
                                    >
                                        {c.icon}
                                    </Icon>

                                    <Typography
                                        key={c.title}
                                        color={
                                            isChildMatch
                                                ? "primary"
                                                : "text.secondary"
                                        }
                                    >
                                        {c.title}
                                    </Typography>
                                </Stack>
                            </Box>
                        );
                    })}
                    <Divider />
                </>
            )}
        </>
    );
}
